module.exports = __webpack_public_path__ + "media/tada.79c09aef.webm";